/* eslint-disable react/prop-types */
import styled from '@emotion/styled';
import Avatar from '@base/Avatar/Avatar';
import P2 from '@base/P2/P2';
import H6 from '@base/H6/H6';
import Link from '@base/Link/Link';
import Tags from '@base/Tags/Tags';
import { dateWithTime } from '@utils/dates';
import Item, { getLessonInfoString } from '@models/Item';
import AuthorHeader from './AuthorHeader';
import MessageDivider from './MessageDivider';
import { Spacings } from '../../../styleConstants';
import Card from './Card';

const Flex = styled.div`
  display: flex;
`;

const StyledCard = styled(Card)`
  margin-top: 16px;
`;

const TimeTag = styled(Tags)`
  color: var(--color-text-secondary);
  margin-bottom: ${Spacings.SPACING_2};
`;

const Content = styled.div`
  margin-left: ${Spacings.SPACING_4B};
  display: flex;
  flex-direction: column;
`;

const LessonInfo = styled(P2)`
  margin-top: ${Spacings.SPACING_2B};
`;

const AuthorName = styled(P2)`
  margin-top: auto;
  color: var(--color-text-primary);
`;

const NewEmbeddedClassCard = ({ story, batch }) => {
  const { message, created_at, author, object } = story;
  const classData = Item.getEntityData({ ...object, ...object.live_class });
  const { liveAtString, name, specialInfoString, relativeLink } = classData;
  return (
    <>
      <AuthorHeader
        author={author}
        created_at={created_at}
        subtitle={batch && object?.collection?.name}
      />
      <StyledCard>
        <MessageDivider message={message} />
        <Link as={relativeLink} href="/class/[slug]/[uid]">
          <Flex>
            <Avatar src={object?.collection?.thumbnail} size="120px" />
            <Content>
              <TimeTag type="transparent">{dateWithTime(liveAtString)}</TimeTag>
              <H6 color="var(--color-text-primary)">{name}</H6>
              <LessonInfo color="var(--color-text-secondary)">
                {specialInfoString || getLessonInfoString(classData, true)}
              </LessonInfo>
              <AuthorName>{`${author.first_name} ${author.last_name}`}</AuthorName>
            </Content>
          </Flex>
        </Link>
      </StyledCard>
    </>
  );
};

export default NewEmbeddedClassCard;
